// extracted by mini-css-extract-plugin
export default {"loading":"job-statistic-card_loading__qqbfW","loadingSm":"job-statistic-card_loadingSm__ZyPNZ","loadingIcon":"job-statistic-card_loadingIcon__NlZYL"};